import React from "react";
import { LegalLayout, LegalSection } from "../components/LegalLayout";
import { TodoSlot } from "../components/TodoSlot";
import { useLanguage } from "../contexts/LanguageContext";
import { BUSINESS } from "../constants";

const Datenschutz = () => {
  const { t } = useLanguage();
  const p = t.legal.privacy;
  const todoLabel = t.legal.todo_label;

  return (
    <LegalLayout title={p.title}>
      <p className="text-base md:text-lg text-white/75 leading-relaxed">
        {p.intro}
      </p>

      <LegalSection title={p.section_responsible}>
        <p>{p.responsible_text}</p>
        <div className="rounded-lg border border-white/10 bg-white/[0.02] p-4 space-y-1.5">
          <p className="font-heading uppercase tracking-wide text-sm text-white">
            {p.responsible_company}
          </p>
          <p>{BUSINESS.owner} (Inhaber)</p>
          <p>{p.responsible_address}</p>
          <p>{p.responsible_phone}</p>
          <p>
            <span className="text-white/40 mr-2">E-Mail:</span>
            <a
              href={BUSINESS.emailHref}
              className="text-white/80 hover:text-[#E63946] transition-colors break-all"
            >
              {BUSINESS.email}
            </a>
          </p>
        </div>
      </LegalSection>

      <LegalSection title={p.section_hosting}>
        <p>{p.hosting_text}</p>
        <p>
          <span className="text-white/50 mr-2">{p.hosting_provider_label}:</span>
          <TodoSlot label={p.hosting_provider_todo} todoLabel={todoLabel} />
        </p>
      </LegalSection>

      <LegalSection title={p.section_form}>
        <p>{p.form_text}</p>
        <p>{p.form_legal}</p>
      </LegalSection>

      <LegalSection title={p.section_whatsapp}>
        <p>{p.whatsapp_text}</p>
        <p>{p.whatsapp_legal}</p>
      </LegalSection>

      <LegalSection title={p.section_maps}>
        <p>{p.maps_text}</p>
        <p>{p.maps_legal}</p>
      </LegalSection>

      <LegalSection title={p.section_fonts}>
        <p>{p.fonts_text}</p>
      </LegalSection>

      <LegalSection title={p.section_rights}>
        <p>{p.rights_intro}</p>
        <ul className="list-disc list-inside space-y-1.5 text-white/75">
          {p.rights_list.map((r, idx) => (
            <li key={idx}>{r}</li>
          ))}
        </ul>
        <p className="text-white/65">{p.rights_authority}</p>
      </LegalSection>

      <LegalSection title={p.section_languages}>
        <p>{p.languages_text}</p>
      </LegalSection>

      <LegalSection title={p.section_changes}>
        <p>{p.changes_text}</p>
      </LegalSection>
    </LegalLayout>
  );
};

export default Datenschutz;
